import { Image } from "@heroui/image";
import React from "react";

import { Img31, TextStrip3 } from "@/public/assets";
import { ApplyForJob, FindTalent } from "@/components";

const TalentHunters = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-10 sm:py-12">
      <div>
        <div
          className="mb-4 text-black dark:text-foreground-950 text-[24px] sm:text-[28px] md:text-[32px] text-center mx-auto font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px]"
          data-aos="fade-up"
        >
          We have dedicated{" "}
          <span className="italic text-primary-600 dark:text-primary relative">
            talent hunters
            <div className="absolute -bottom-1 inset-x-0">
              <Image
                disableSkeleton
                alt="strip 2 image"
                className="animate__animated animate__flipInX w-full"
                src={TextStrip3.src}
              />
            </div>
          </span>{" "}
          on <br /> standby, prepared to act at your request.
        </div>

        <div
          className="text-foreground-700 dark:text-foreground-600 font-normal text-sm sm:text-base leading-5 sm:leading-6 tracking-[-0.176px] mb-6 text-center max-w-3xl px-2 sm:px-6 md:px-10 mx-auto"
          data-aos="fade-up"
        >
          When you make the call, we get to work. Our recruitment team moves
          fast to find, screen, and present business-ready candidates so your
          hiring never slows your growth.
        </div>

        <div
          className="flex flex-col sm:flex-row items-center mb-9 gap-3 justify-center mx-auto max-w-md"
          data-aos="fade-up"
        >
          <FindTalent />
          <ApplyForJob />
        </div>

        <div data-aos="zoom-in">
          <Image
            removeWrapper
            className="object-cover object-[50%_40%] h-[35vh] sm:h-[45vh] md:h-[50vh] w-full sm:w-11/12 md:w-10/12 mx-auto rounded-[32px]"
            src={Img31.src}
          />
        </div>
      </div>
    </section>
  );
};

export default TalentHunters;
